import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="mr-3 text-blue-400 mt-1" />
                <span>16 Jalan Sejati 6, Taman Tasik Sejati, 85000 Segamat, Johor</span>
              </li>
              <li className="flex items-center">
                <FaPhone className="mr-3 text-blue-400" />
                <span>013-740 8829</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-3 text-blue-400" />
                <span>mikhaelhomestay@gmail.com</span>
              </li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link 
                  to="/#booking-platforms" 
                  className="hover:text-blue-400 transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    
                    // If we're already on the home page
                    if (location.pathname === '/' || location.pathname === '') {
                      const targetElement = document.getElementById('booking-platforms');
                      if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                      }
                    } else {
                      // If we're on another page, navigate to home page with the hash
                      navigate('/?scrollTo=booking-platforms');
                    }
                  }}
                >
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/house-rules" className="hover:text-blue-400 transition-colors">House Rules</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link>
              </li>
            </ul>
          </div>
          
          {/* Business Information */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Business Information</h3>
            <div className="space-y-3">
              <div>
                <p className="font-medium text-blue-300">MIKAZAN TRADING</p>
              </div>
              <div className="text-sm space-y-2">
                <p className="flex items-center">
                  <span className="mr-2">•</span>
                  <span>Registration Number: 202503154242</span>
                </p>
                <p className="flex items-center">
                  <span className="mr-2">•</span>
                  <span>Business Registration Number: LA0079483-A</span>
                </p>
              </div>
              <div className="mt-4">
                <p className="text-sm text-gray-400">Address:</p>
                <p className="text-sm">16 Jalan Sejati 6, Taman Tasik Sejati,<br />85000 Segamat, Johor</p>
              </div>
            </div>
            
            <div className="mt-6">
              <h4 className="font-medium mb-2">Follow Us</h4>
              <div className="flex space-x-4">
                <a href="#" className="text-2xl hover:text-blue-400 transition-colors" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="#" className="text-2xl hover:text-blue-400 transition-colors" aria-label="Instagram">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} Mikhael Homestay. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
